<template>
    <div class="owl-carousel owl-theme carousel-component">
        <router-link v-for="item in data.items" :key="item.ID" :to="{ name: data.type+'Details', params: { Id: item.ID }, }" class="item">
            <div class="card press-carousel-w press-carousel-w-m custom-carousel">
                <img :src="item.Image ? sharedDirectory + data.type +'Image/' + item.Image : sharedDirectory + 'DefaultImages/image_not_available.png'" class="card-img-top" alt="No Image">
                <div class="card-body carousel-body">
                    <h5 class="card-title">{{ item.Title }}</h5>
                    <div class="card-text carousel-description text-secondary" v-html="item.PreviewDescription"></div>
                </div>
            </div>
        </router-link>
    </div>
</template>
  
<script>

export default {
  name: 'Carousel',
  props: ['data'],
  data() {
    return {
      sharedDirectory: process.env.VUE_APP_SHARED_DIRECTORY
    }
  },
  mounted() {
    window.$('.owl-carousel').owlCarousel({
      margin:10,
      nav:true,
      autoplay:true,
      autoplayTimeout:3000,
      autoplayHoverPause:true,
      responsive:{
        0:{
          items:1,
          loop: this.data.items.length > 1
        },
        768:{
          items:2,
          loop: this.data.items.length > 2
        },
        992:{
          items:2,
          loop: this.data.items.length > 2
        },
        1200:{
          items:3,
          loop: this.data.items.length > 3
        }
      }
    })
    window.$( '.owl-prev' ).addClass( 'btn btn-outline-secondary' )
    window.$( '.owl-next' ).addClass( 'btn btn-outline-secondary' )
    window.$( '.owl-prev' ).html( '<' )
    window.$( '.owl-next' ).html( '>' )
  },
  methods: {

  },
}
</script>
  